// extracted by mini-css-extract-plugin
module.exports = {"frequency_table_container":"frequencyTable_frequency_table_container__3PxOL","frequency_table_header":"frequencyTable_frequency_table_header__4cM2M"};